<template>
  <action-button
    v-if="permission?.display"
    :text="permission?.display"
    :disabled="disabled"
    :rounded="true"
    @action-click="onClick"
  />
</template>
<script setup>
  import {
    showLoginPopup,
    showVoucherPopup,
  } from '@/common/utils/scalable.player'
  import ActionButton from '@/components/player/ActionButton.vue'
  import { computed } from 'vue'

  const props = defineProps({
    contentInfo: {
      type: Object,
    },
    permission: {
      type: Object,
      default: () => {},
    },
  })

  const disabled = computed(() => props.permission.action === 'memo')

  const onClick = () => {
    switch (props.permission.action) {
      case 'login':
        showLoginPopup()
        break
      case 'stream':
        window.playerInstance.play()
        break
      case 'purchase':
        showVoucherPopup({
          type: 'live',
          contentInfo: props.contentInfo,
        })
        break
      case 'none':
        break
    }
  }
</script>
